export default "__VITE_ASSET__DLtQdBvM__"